// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"80":"user-mgt","227":"multinational","240":"direct","413":"container","794":"e-learning","921":"permission-mgt","948":"end-user"}[chunkId] + "." + {"80":"2f7d970b","227":"0cd288bd","240":"bc632b26","413":"da856c56","794":"98be2438","921":"10b5ff84","948":"de61302b"}[chunkId] + ".css";
};